import { Call } from '@src/services/api';
import { Analytics } from 'common/dist/types/apiTypes';
import type { ResGetSocialTopProducts } from 'common/dist/types/apiTypes';

export const getStatistics = async (): Promise<Analytics[]> => {
  const res = await Call.get<Analytics[]>('/api/analytics');
  return res || [];
};

export const getSocialTopProducts = (params: {
  from?: string;
  to?: string;
  limit: number;
}): Promise<ResGetSocialTopProducts> => Call.get('/api/analytics/social/top-products', params);
